var _path, _path2, _path3, _g, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _g2, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPollyInformational(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 55C42.6878 55 55 42.6878 55 27.5C55 12.3122 42.6878 0 27.5 0C12.3122 0 0 12.3122 0 27.5C0 42.6878 12.3122 55 27.5 55Z",
    fill: "#FAAB35"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7810_4931",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 55,
    height: 55
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 55C42.6878 55 55 42.6878 55 27.5C55 12.3122 42.6878 0 27.5 0C12.3122 0 0 12.3122 0 27.5C0 42.6878 12.3122 55 27.5 55Z",
    fill: "#FAAB35"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7810_4931)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_7810_4931",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 34,
    width: 17,
    height: 17
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3502 45.5345C34.7415 45.2799 34.3597 45.1205 34.3597 45.1205C31.9415 43.8405 32.3683 37.8664 32.3683 37.8664C32.3683 37.8664 29.7974 35.9069 27.7287 34.768V34.6697C27.6991 34.6852 27.6695 34.7028 27.6399 34.7188C27.61 34.7028 27.5807 34.6852 27.5508 34.6697V34.768C25.4822 35.9069 22.9112 37.8664 22.9112 37.8664C22.9112 37.8664 23.338 43.8405 20.9199 45.1205C20.9199 45.1205 20.5382 45.2799 19.9293 45.5345C21.3454 48.6544 24.2618 50.8014 27.6399 50.8014C31.018 50.8014 33.9344 48.6544 35.3502 45.5345Z",
    fill: "#A06A4B"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_7810_4931)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.3538 45.5345C35.7451 45.2799 35.3632 45.1205 35.3632 45.1205C32.9451 43.8405 33.3718 37.8664 33.3718 37.8664C33.3718 37.8664 30.8009 35.9069 28.7322 34.768V34.6697C28.7026 34.6852 28.673 34.7028 28.6434 34.7188C28.6136 34.7028 28.5842 34.6852 28.5544 34.6697V34.768C26.4857 35.9069 23.9148 37.8664 23.9148 37.8664C23.9148 37.8664 24.3415 43.8405 21.9234 45.1205C21.9234 45.1205 21.5418 45.2799 20.9329 45.5345C22.3489 48.6544 25.2654 50.8014 28.6434 50.8014C32.0215 50.8014 34.9379 48.6544 36.3538 45.5345Z",
    fill: "#A06A4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7217 40.1016C33.7217 40.1016 28.6543 46.2358 19.5332 45.169C16.7076 44.8385 21.7378 36.705 21.7378 36.705L32.4677 37.8428L33.7217 40.1016Z",
    fill: "#764D34"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1688 46.3698H35.1812C35.1812 48.5345 31.8134 50.2893 27.659 50.2893C23.5044 50.2893 20.1364 48.5345 20.1364 46.3698H18.0738C18.0738 46.3698 10.4891 48.4183 10.7538 49.3918C12.47 55.7069 19.3867 60.4303 27.659 60.4303C35.8696 60.4303 42.7447 55.7771 44.5248 49.5328C44.8149 48.5162 37.1688 46.3698 37.1688 46.3698Z",
    fill: "#A2DADD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7638 41.4351C22.7638 41.4351 18.1072 41.8297 18.1072 46.369C18.1072 50.9082 23.3705 53.5579 27.6287 53.3926C28.8157 53.3466 28.3317 48.2439 28.3317 48.2439C28.3317 48.2439 21.8819 48.9748 22.7638 41.4351Z",
    fill: "#26ACAF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5162 41.4351C32.5162 41.4351 37.1728 41.8297 37.1728 46.369C37.1728 50.9082 31.8869 53.5579 27.6287 53.3926C26.4412 53.3466 26.9483 48.2439 26.9483 48.2439C26.9483 48.2439 33.3981 48.9748 32.5162 41.4351Z",
    fill: "#26ACAF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8569 18.751C31.8066 18.751 30.1447 17.0888 30.1447 15.0384C30.1447 12.9884 31.8066 11.3262 33.8569 11.3262C35.9073 11.3262 37.5692 12.9884 37.5692 15.0384C37.5692 17.0888 35.9073 18.751 33.8569 18.751Z",
    fill: "#231F20"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6688 17.8076C25.1955 17.8076 23.1903 15.8024 23.1903 13.3291C23.1903 10.8558 25.1955 8.85059 27.6688 8.85059C30.1422 8.85059 32.1473 10.8558 32.1473 13.3291C32.1473 15.8024 30.1422 17.8076 27.6688 17.8076Z",
    fill: "#231F20"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5171 21.897C35.7796 21.897 34.3711 20.4884 34.3711 18.751C34.3711 17.0133 35.7796 15.6047 37.5171 15.6047C39.2546 15.6047 40.6631 17.0133 40.6631 18.751C40.6631 20.4884 39.2546 21.897 37.5171 21.897Z",
    fill: "#231F20"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5692 26.3158C35.8317 26.3158 34.4235 24.9073 34.4235 23.1698C34.4235 21.4321 35.8317 20.0236 37.5692 20.0236C39.3069 20.0236 40.7152 21.4321 40.7152 23.1698C40.7152 24.9073 39.3069 26.3158 37.5692 26.3158Z",
    fill: "#231F20"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1652 30.6111C34.4277 30.6111 33.0192 29.2026 33.0192 27.4651C33.0192 25.7274 34.4277 24.3188 36.1652 24.3188C37.9026 24.3188 39.3112 25.7274 39.3112 27.4651C39.3112 29.2026 37.9026 30.6111 36.1652 30.6111Z",
    fill: "#231F20"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M21.423 18.751C23.4733 18.751 25.1352 17.0888 25.1352 15.0384C25.1352 12.9884 23.4733 11.3262 21.423 11.3262C19.3726 11.3262 17.7107 12.9884 17.7107 15.0384C17.7107 17.0888 19.3726 18.751 21.423 18.751Z",
    fill: "#231F20"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7629 21.897C19.5004 21.897 20.9089 20.4884 20.9089 18.751C20.9089 17.0133 19.5004 15.6047 17.7629 15.6047C16.0255 15.6047 14.6169 17.0133 14.6169 18.751C14.6169 20.4884 16.0255 21.897 17.7629 21.897Z",
    fill: "#231F20"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7107 26.3158C19.4482 26.3158 20.8567 24.9073 20.8567 23.1698C20.8567 21.4321 19.4482 20.0236 17.7107 20.0236C15.9732 20.0236 14.5647 21.4321 14.5647 23.1698C14.5644 24.9073 15.973 26.3158 17.7107 26.3158Z",
    fill: "#231F20"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1145 30.6111C20.852 30.6111 22.2605 29.2026 22.2605 27.4651C22.2605 25.7274 20.852 24.3188 19.1145 24.3188C17.377 24.3188 15.9685 25.7274 15.9685 27.4651C15.9685 29.2026 17.377 30.6111 19.1145 30.6111Z",
    fill: "#231F20"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_7810_4931",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 15,
    width: 21,
    height: 27
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7985 20.9576C35.3762 16.0503 30.2553 15.5525 28.1217 15.5525H27.5193H26.9167C24.783 15.5525 19.6625 16.0503 18.2401 20.9576C16.8236 25.8443 16.3544 41.4343 27.5193 41.4343C38.6862 41.4345 38.2148 25.8443 36.7985 20.9576Z",
    fill: "#A06A4B"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_7810_4931)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.7985 20.9576C35.3762 16.0503 30.2553 15.5525 28.1217 15.5525H27.5193H26.9167C24.783 15.5525 19.6625 16.0503 18.2401 20.9576C16.8236 25.8443 16.3544 41.4343 27.5193 41.4343C38.6862 41.4345 38.2148 25.8443 36.7985 20.9576Z",
    fill: "#A06A4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5455 18.8052C30.5455 18.8052 37.6233 23.7837 34.0277 27.9985C31.2061 31.3064 34.0277 31.4647 34.0277 31.4647C34.0277 31.4647 34.8457 37.5811 33.4943 39.5724C38.9697 39.2842 55.4448 20.3246 30.5455 18.8052Z",
    fill: "#764D34"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7273 37.1711C24.2403 37.1711 26.2773 35.1177 26.2773 32.5847C26.2773 30.0519 24.2403 27.9985 21.7273 27.9985C19.2143 27.9985 17.1772 30.0519 17.1772 32.5847C17.1772 35.1177 19.2143 37.1711 21.7273 37.1711Z",
    fill: "#A06A4B"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4946 37.1711C36.0076 37.1711 38.0446 35.1177 38.0446 32.5847C38.0446 30.0519 36.0076 27.9985 33.4946 27.9985C30.9814 27.9985 28.9443 30.0519 28.9443 32.5847C28.9443 35.1177 30.9814 37.1711 33.4946 37.1711Z",
    fill: "#A06A4B"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3765 30.3622C37.3765 30.3622 37.4051 18.4664 27.8554 18.4664C18.3053 18.4664 23.0804 17.3828 23.0804 17.3828L27.5521 14.2712C27.5521 14.2712 41.865 12.8488 37.3765 30.3622Z",
    fill: "#F47C24"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M17.734 30.3622C17.734 30.3622 17.7054 18.4664 27.2553 18.4664C31.3813 18.4664 32.232 18.5901 32.0303 17.3828C31.7328 15.6047 27.5586 14.2712 27.5586 14.2712C27.5586 14.2712 13.2457 12.8488 17.734 30.3622Z",
    fill: "#FAAB35"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1466 32.5847C21.1602 32.5847 21.9822 31.7628 21.9822 30.7491C21.9822 29.7355 21.1602 28.9136 20.1466 28.9136C19.133 28.9136 18.311 29.7355 18.311 30.7491C18.311 31.7628 19.1327 32.5847 20.1466 32.5847Z",
    fill: "#AF8065"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1332 32.5847C36.1468 32.5847 36.9687 31.7628 36.9687 30.7491C36.9687 29.7355 36.1468 28.9136 35.1332 28.9136C34.1195 28.9136 33.2979 29.7355 33.2979 30.7491C33.2979 31.7628 34.1195 32.5847 35.1332 32.5847Z",
    fill: "#AF8065"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3217 28.9685C24.4068 28.697 24.4592 28.3636 24.4592 27.9985C24.4592 27.1003 24.1539 26.3722 23.7775 26.3722C23.4009 26.3722 23.0958 27.1003 23.0958 27.9985C23.0958 28.3447 23.1417 28.6641 23.219 28.9278C23.3389 28.9193 23.4616 28.9138 23.5881 28.9138C23.8475 28.9138 24.0936 28.9338 24.3217 28.9685Z",
    fill: "#231F20"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M32.054 28.9469C32.135 28.6794 32.1842 28.3535 32.1842 27.9985C32.1842 27.1003 31.8788 26.3722 31.5025 26.3722C31.1259 26.3722 30.8206 27.1003 30.8206 27.9985C30.8206 28.3535 30.8695 28.6794 30.9505 28.9469C31.1272 28.9273 31.3098 28.9138 31.5025 28.9138C31.6952 28.9135 31.8778 28.9273 32.054 28.9469Z",
    fill: "#231F20"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1997 25.546C24.8078 24.9596 24.2538 24.5916 23.6376 24.5916C22.6721 24.5916 21.8555 25.4903 21.584 26.7277C22.1149 25.8872 23.0402 25.3289 24.0955 25.3289C24.4856 25.3289 24.8574 25.4072 25.1997 25.546Z",
    fill: "#231F20"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0801 24.1274C30.472 23.541 31.026 23.173 31.6422 23.173C32.6079 23.173 33.4245 24.0717 33.696 25.3091C33.1651 24.4686 32.2395 23.9104 31.1843 23.9104C30.7939 23.9104 30.4221 23.9886 30.0801 24.1274Z",
    fill: "#231F20"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9849 27.9985C27.9849 27.9985 29.3053 31.2886 29.2383 31.7492C28.7762 32.5849 27.9849 32.5849 27.9849 32.5849C27.9849 32.5849 28.3996 31.766 28.3494 31.1445C28.312 30.6856 27.9849 27.9985 27.9849 27.9985Z",
    fill: "#764D34"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9481 37.8765C25.9481 37.8765 28.2694 38.9845 29.7798 37.171C29.7798 37.171 29.2509 38.426 28.2014 38.6613C26.8288 38.9689 25.9481 37.8765 25.9481 37.8765Z",
    fill: "#764D34"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5868 37.5525C28.8581 37.5525 29.8885 36.7278 29.8885 35.7104C29.8885 34.693 28.8583 33.868 27.5868 33.868C26.3155 33.868 25.285 34.693 25.285 35.7104C25.285 36.7278 26.3155 37.5525 27.5868 37.5525Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_7810_4931",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 25,
    y: 33,
    width: 5,
    height: 5
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5868 37.5525C28.8581 37.5525 29.8885 36.7278 29.8885 35.7104C29.8885 34.693 28.8583 33.868 27.5868 33.868C26.3155 33.868 25.285 34.693 25.285 35.7104C25.285 36.7278 26.3155 37.5525 27.5868 37.5525Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_7810_4931)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.3064 34.9976H24.457V38.682H33.3064V34.9976Z",
    fill: "#231F20"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPollyInformational);
export default __webpack_public_path__ + "static/media/pollyInformational.aef0bd51.svg";
export { ForwardRef as ReactComponent };